module.exports = __webpack_public_path__ + "static/img/Channel.bdcfee5d.png";